export function request(req, token) {
    this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
}
export function response(res) {
    return (res.data || {}).access_token;
}